module.exports = __webpack_public_path__ + "static/media/icon-body-front.9b9ef57f.png";